import React from 'react';
import { css } from 'styled-components';
import { applyStyles, minResolution } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import i18n from 'i18n';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import Tag from 'components/common/Tag';
import { Field } from 'react-final-form';
import LicenceDialog from './LicenceDialog';
import icTermsOn1x from 'assets/images/common/@1x/ic_terms_on.png';
import icTermsOn2x from 'assets/images/common/@2x/ic_terms_on@2x.png';
import icTermsOn3x from 'assets/images/common/@3x/ic_terms_on@3x.png';
import icTermsOff1x from 'assets/images/common/@1x/ic_terms_off.png';
import icTermsOff2x from 'assets/images/common/@2x/ic_terms_off@2x.png';
import icTermsOff3x from 'assets/images/common/@3x/ic_terms_off@3x.png';

const checkAgreement = ({ form }) =>
  form.getFieldState('agreement') && form.getFieldState('agreement').value;

class Agreement extends React.Component {
  constructor(props) {
    super(props);
    this.LicenceDialogRef = React.createRef();
  }

  changeAgreement(form, value) {
    const { change } = form;
    change('agreement', value);
  }

  render() {
    const { className, form } = this.props;
    return (
      <div className={className}>
        <Field
          name="agreement"
          type="checkbox"
          validate={value => !value}
          render={({ input }) => (
            <div className="checkbox-wrapper">
              <input type="checkbox" {...input} hidden />
              <label
                htmlFor="agreement"
                onClick={() => this.LicenceDialogRef.current.open()}
              >
                <div className="terms-icon" />
                <a>{i18n.t('orderAggregators:confirmation:licence')}</a>
                {i18n.t('orderAggregators:confirmation:agreeToLicence')}
              </label>
              <Tag>{i18n.t('common:required')}</Tag>
            </div>
          )}
        />
        <ul className="agreement-note">
          <li>{i18n.t('orderAggregators:confirmation:agreementNotes1')}</li>
          <li>{i18n.t('orderAggregators:confirmation:agreementNotes2')}</li>
        </ul>

        <LicenceDialog
          dialogRef={this.LicenceDialogRef}
          handleChangeAgreement={value => this.changeAgreement(form, value)}
        />
      </div>
    );
  }
}

const commonStyle = css`
  label {
    ${FontStyles.text5};

    display: flex;
    align-items: center;
    margin: 0 8px 0 0;
    color: ${Colors.black1};
    cursor: pointer;

    .terms-icon {
      position: relative;
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;

      &::after {
        position: absolute;
        top: 0;
        display: inline-block;
        width: 20px;
        height: 20px;
        background-size: 20px;
        content: '';

        background-image: url('${props =>
          checkAgreement(props) ? icTermsOn1x : icTermsOff1x}');

        ${minResolution(2)`
          background-image: url('${props =>
            checkAgreement(props) ? icTermsOn2x : icTermsOff2x}');`}

        ${minResolution(3)`
          background-image: url('${props =>
            checkAgreement(props) ? icTermsOn3x : icTermsOff3x}');`}
      }
    }

    a {
      color: ${Colors.orange1} !important;
    }
  }

  .agreement-note {
    padding-left: 12px;

    li {
      position: relative;
      list-style: none;

      &:before {
        position: absolute;
        top: 0.6rem;
        left: -0.7rem;
        content: '';
        display: inline-block;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: ${Colors.black1};
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  padding-top: 72px;
  border-top: 1px solid ${Colors.gray2};

  .checkbox-wrapper {
    display: flex;
    align-items: center;
  }

  .agreement-note {
    ${FontStyles.text8};
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 32px 0;

  .checkbox-wrapper {
    display: flex;
    align-items: center;
  }

  .agreement-note {
    ${FontStyles.text6};
  }
`;

export default applyStyles(Agreement)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/Agreement.js